import { PhoneIcon } from "@heroicons/react/24/solid";
import { EventFragment } from "../../../../__generated__/graphql";
import useContacts from "../../../../pages/contacts/hooks/useContacts";
import { useState } from "react";
import Button from "../../../Button";
import CreateContactModal from "../../../../pages/contacts/components/CreateContactModal";
import ContactItem from "../../../../pages/contacts/components/ContactItem";

export default function EventContacts({ event }: { event: EventFragment }) {
  const [isCreateContactModalOpen, setIsCreateContactModalOpen] =
    useState(false);

  const { data, refetch: refetchContacts } = useContacts({
    eventId: event.id,
  });

  return (
    <>
      <CreateContactModal
        eventId={event.id}
        isOpen={isCreateContactModalOpen}
        onClose={() => {
          setIsCreateContactModalOpen(false);
        }}
      />

      <div className="w-full h-fit rounded-md p-4 border border-input flex flex-col gap-4">
        <div className="flex justify-between items-center">
          <div className="flex flex-col">
            <div className="text-lg font-bold text-primary flex items-center gap-2">
              <PhoneIcon className="w-4 h-4" />
              Contacts
            </div>
          </div>

          <Button
            variant="secondary"
            className="text-sm"
            onClick={() => {
              setIsCreateContactModalOpen(true);
            }}
          >
            + Ajouter un contact
          </Button>
        </div>

        <div className="flex flex-col gap-2">
          {data?.contacts.length === 0 && (
            <div className="text-tertiary text-sm text-center">
              Aucun contact
            </div>
          )}

          {data?.contacts.map((contact) => (
            <ContactItem
              key={contact.id}
              contact={contact}
              onDelete={() => {
                refetchContacts();
              }}
            />
          ))}
        </div>
      </div>
    </>
  );
}
